export const captureEvent = (eventName, properties = {}) => {
  if (typeof posthog === "undefined") {
    return;
  }

  posthog.capture(eventName, properties);
};
